module.exports = __webpack_public_path__ + "static/media/goncalo_ferreira.af4860d1.jpg";